import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

export const StyledCategoryStats = styled.div``;

export const StyledCategoryDescription = styled.div`
  width: 95%;
  color: ${getColor('shuttleGray')};
  font-weight: 400;
  letter-spacing: 0.2px;
  min-height: 10rem;
`;

export const StyledPieChart = styled.div`
  margin-top: 1rem;
  margin-bottom: 4rem;
  display: flex;
  width: 100%;
  height: 28rem;
  align-items: center;
  justify-content: center;
`;
